import { createDashboardModule } from './dashboardHostModule';
import { createHost } from './hostPlatform';

export const dashboard = createDashboardModule({
  createHost,
});

export * from './types';
